<template>
    <Paginator
        :template="{
            '640px': 'PrevPageLink CurrentPageReport NextPageLink',
            '960px': 'FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink',
            '1300px': 'FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink',
            // default: 'FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink JumpToPageDropdown JumpToPageInput'
            default: 'CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink JumpToPageInput RowsPerPageDropdown'
        }"
        :rows="rows"
        :totalRecords="totalRecords"
    >
        <template #start="slotProps">
            {{ lang.page }}: {{ slotProps.state.page }}
            {{ lang.first}}: {{ slotProps.state.first }}
            {{ lang.rows }}: {{ slotProps.state.rows }}
        </template>
        <template #end>
            <button @click="buttonCallback($event)"><i class="fas fa-search me-2"></i> {{ buttonLabel }}</button>
        </template>
    </Paginator>

</template>


<script>
import Paginator from 'primevue/paginator';


export default {
    name: "PaginatorC",
    components: {
        Paginator,
    },
    props:{
        data: {
            type: Object,
            default: () => {}
        },
        lang: {
            type: Object,
            default: () => {}
        },
        rows: {
            type: Number,
            default: 10
        },
        totalRecords: {
            type: Number,
            default: 0
        },
        buttonLabel: {
            type: String,
            default: ""
        },
        buttonCallback: {
            type: Function,
            default: () => {}
        },

    },
    setup() {
        return {};
    },
}
</script>